<div class="dashboard-container" *ngIf="!loadingPermissions; else carregandoTemplate">
    <div class="section-container" *ngIf="hasLevelCnf">
        <h2 class="section-title">Financeiro</h2>
        <div class="section-body" [class.is-loading]="carregandoFinanceiro">
            <div class="months-panel">
            <mat-card class="month-card mes-1 clickable" (click)="navegarParaControleFinanca(mesAnterior)">
                <div class="month-card__header">
                    <div class="month-card__header-left">
                        <mat-icon class="month-card__icon">event</mat-icon>
                        <span class="month-card__title">{{ mesAnterior.mes }}/{{ mesAnterior.ano }}</span>
                    </div>
                    <span class="month-card__badge" matTooltip="Mês anterior">
                        Mês Anterior
                    </span>
                </div>
                <div class="month-card__content" *ngIf="mesAnterior.idControleFinanca">
                    <div class="value-row">
                        <div class="value-label">Entrada</div>
                        <div class="value-amount">{{ mesAnterior.vlEntrada | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</div>
                    </div>
                    <div class="value-row">
                        <div class="value-label">Saída</div>
                        <div class="value-amount">{{ mesAnterior.vlSaida | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</div>
                    </div>
                    <div class="value-row total-row">
                        <div class="value-label">Saldo</div>
                        <div class="value-amount" [ngClass]="{
                            'saldo-positivo': mesAnterior.vlSaldo > 0, 
                            'saldo-negativo': mesAnterior.vlSaldo < 0
                        }">
                            {{ mesAnterior.vlSaldo | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
                            <mat-icon class="saldo-icon" *ngIf="mesAnterior.vlSaldo > 0">arrow_upward</mat-icon>
                            <mat-icon class="saldo-icon" *ngIf="mesAnterior.vlSaldo < 0">arrow_downward</mat-icon>
                        </div>
                    </div>
                </div>
                <div class="month-card__content" *ngIf="!mesAnterior.idControleFinanca">
                    <div class="no-finance-data-message">
                        <p>Dados não disponíveis para o mês anterior.</p>
                    </div>
                </div>
            </mat-card>
            
            <mat-card class="month-card mes-2 clickable" (click)="navegarParaControleFinanca(mesAtual)">
                <div class="month-card__header">
                    <div class="month-card__header-left">
                        <mat-icon class="month-card__icon">event</mat-icon>
                        <span class="month-card__title">{{ mesAtual.mes }}/{{ mesAtual.ano }}</span>
                    </div>
                    <span class="month-card__badge" matTooltip="Mês atual">
                        Mês Atual
                    </span>
                </div>
                <div class="month-card__content" *ngIf="mesAtual.idControleFinanca">
                    <div class="value-row">
                        <div class="value-label">Entrada</div>
                        <div class="value-amount">{{ mesAtual.vlEntrada | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</div>
                    </div>
                    <div class="value-row">
                        <div class="value-label">Saída</div>
                        <div class="value-amount">{{ mesAtual.vlSaida | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</div>
                    </div>
                    <div class="value-row total-row">
                        <div class="value-label">Saldo</div>
                        <div class="value-amount" [ngClass]="{
                            'saldo-positivo': mesAtual.vlSaldo > 0, 
                            'saldo-negativo': mesAtual.vlSaldo < 0
                        }">
                            {{ mesAtual.vlSaldo | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
                            <mat-icon class="saldo-icon" *ngIf="mesAtual.vlSaldo > 0">arrow_upward</mat-icon>
                            <mat-icon class="saldo-icon" *ngIf="mesAtual.vlSaldo < 0">arrow_downward</mat-icon>
                        </div>
                    </div>
                </div>
                <div class="month-card__content" *ngIf="!mesAtual.idControleFinanca">
                    <div class="no-finance-data-message">
                        <p>Dados não disponíveis para este mês.</p>
                    </div>
                </div>
            </mat-card>
            <mat-card class="month-card mes-3 clickable" (click)="navegarParaControleFinanca(mesProximo)">
                <div class="month-card__header">
                    <div class="month-card__header-left">
                        <mat-icon class="month-card__icon">event</mat-icon>
                        <span class="month-card__title">{{ mesProximo.mes }}/{{ mesProximo.ano }}</span>
                    </div>
                    <span class="month-card__badge" matTooltip="Próximo mês">
                        Próximo Mês
                    </span>
                </div>
                <div class="month-card__content" *ngIf="mesProximo.idControleFinanca">
                    <div class="value-row">
                        <div class="value-label">Entrada</div>
                        <div class="value-amount">{{ mesProximo.vlEntrada | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</div>
                    </div>
                    <div class="value-row">
                        <div class="value-label">Saída</div>
                        <div class="value-amount">{{ mesProximo.vlSaida | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}</div>
                    </div>
                    <div class="value-row total-row">
                        <div class="value-label">Saldo</div>
                        <div class="value-amount" [ngClass]="{
                            'saldo-positivo': mesProximo.vlSaldo > 0, 
                            'saldo-negativo': mesProximo.vlSaldo < 0
                        }">
                            {{ mesProximo.vlSaldo | currency:'BRL':'symbol':'1.2-2':'pt-BR' }}
                            <mat-icon class="saldo-icon" *ngIf="mesProximo.vlSaldo > 0">arrow_upward</mat-icon>
                            <mat-icon class="saldo-icon" *ngIf="mesProximo.vlSaldo < 0">arrow_downward</mat-icon>
                        </div>
                    </div>
                </div>
                <div class="month-card__content" *ngIf="!mesProximo.idControleFinanca">
                    <div class="no-finance-data-message">
                        <p>Dados não disponíveis para o próximo mês.</p>
                    </div>
                </div>
            </mat-card>
        </div>

            <div class="section-overlay" *ngIf="carregandoFinanceiro">
                <mat-spinner diameter="36"></mat-spinner>
            </div>
        </div>
    </div>

    <div class="section-container" *ngIf="hasLevelAbs">
        <h2 class="section-title">Meus Veículos</h2>
        <div class="section-body" [class.is-loading]="carregandoVeiculos">
            <div class="vehicles-panel">
                <mat-card class="vehicle-card clickable" *ngFor="let veiculo of veiculos">
                    <div class="vehicle-card__header" (click)="navegarParaVeiculo(veiculo)">
                        <div class="vehicle-card__header-left">
                            <mat-icon class="vehicle-card__icon">directions_car</mat-icon>
                            <span class="vehicle-card__title">{{ veiculo.dsModelo }}</span>
                        </div>
                        <span class="vehicle-card__badge" matTooltip="Placa">
                            {{ veiculo.dsPlaca }}
                        </span>
                    </div>
                    <div class="vehicle-card__content" (click)="navegarParaVeiculo(veiculo)">
                        <div class="vehicle-info">
                            <p><strong>Marca:</strong> {{ veiculo.dsMarca }}</p>
                            <p><strong>Cor:</strong> {{ veiculo.dsCor }}</p>
                        </div>
                        <div class="vehicle-actions">
                            <button mat-mini-fab color="primary" 
                                    (click)="onAbastecimento(veiculo, $event)"
                                    matTooltip="Abastecimentos"
                                    class="action-button">
                                <mat-icon>local_gas_station</mat-icon>
                            </button>
                            <button mat-mini-fab color="primary" 
                                    (click)="onUsuarios(veiculo, $event)"
                                    matTooltip="Usuários"
                                    class="action-button">
                                <mat-icon>people</mat-icon>
                            </button>
                        </div>
                    </div>
                </mat-card>
                <div *ngIf="veiculos.length === 0" class="clickable no-data-message" (click)="navegarParaAdicionarVeiculo()">
                    <p>Nenhum veículo encontrado.</p>
                </div>
            </div>

            <div class="section-overlay" *ngIf="carregandoVeiculos">
                <mat-spinner diameter="36"></mat-spinner>
            </div>
        </div>
    </div>

    <div class="no-role-message" *ngIf="!hasAnyRole">
        <mat-icon class="no-role-icon">lock</mat-icon>
        <h2>Acesso Restrito</h2>
        <p>Redirecionando para o login..</p>
    </div>
</div>

<ng-template #carregandoTemplate>
    <div class="carregando-container">
        <mat-spinner></mat-spinner>
        <p>Carregando...</p>
    </div>
</ng-template>